import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { LegalPage } from '~/modules/legal';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

import { legalSearchDefaults, zodLegalSearchSchema } from './-searchParams';

const title = i18n.t(($) => $.pageTitle, { ns: 'legal' });

export const Route = createFileRoute('/(main)/legal/')({
  component: LegalPage,
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(legalSearchDefaults)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodLegalSearchSchema,
});

export const LEGAL = buildRouteExport({ Route });
